import * as React from 'react';
import { IAppState } from '../classes/app';
import { Dispatch } from 'redux';
import { upsertFilter, removeFilter } from '../redux-state/actions/filters';
import { IOption } from '../classes/input-option';
import { goToPage } from '../redux-state/actions/listing';

export interface IExternalProps {
    property: string;
    title: string;
    description?: string;
    defaultOption?: IOption;
    defaultTextBoxValue?: string;
    options?: IOption[];
    searchByLocationdefaultValue?: string;
}

interface StateToProps {
    options?: IOption[];
    selectedOptions?: string;
    matching?: { [id: number]: number }
    loading?: boolean;
    IsDisabled?: boolean;
}

interface DispatchToProps {
    updateFilter: (query: string) => void;
    updateSecondaryFilter: (property: string, query: string) => void;
}

export type FiltersProps = IExternalProps & StateToProps & DispatchToProps;

export class FilterBase<T extends FiltersProps = FiltersProps> extends React.Component<T, null> {



    protected convertEvtToString(evt): string {
        return evt.currentTarget.value;
    }

    protected updateValue(evt) {
        const updatedValue = this.convertEvtToString(evt);

        this.setState({
            currentValue: updatedValue
        });
    }

    private updateFilter(overrideString: string, isSelection?: boolean) {
        if (isSelection) {
            this.props.updateFilter(overrideString);
        } else {
            this.props.updateFilter(this.props.selectedOptions);
        }
    }

    protected boundValueUpdate = this.updateValue.bind(this);
    protected boundFilterUpdate = this.updateFilter.bind(this);

    protected renderFormElement(): JSX.Element {
        return;
    }

    render() {
        return (
            <div className="adage-search-facet">
                {this.renderFormElement()}

                {
                    this.props.description ? <p>{this.props.description}</p> : null
                }
            </div>
        )
    }
}

export function mapStateToProps(state: IAppState, ownProps: IExternalProps): StateToProps {
    const options = state.filtersState.filterOptions[ownProps.property];

    if (ownProps.property === "hospital" || ownProps.property === "practice") {
        return {
            IsDisabled: false,
            options: options ? Object.keys(options).map(function (key) { return { text: options[key], value: key } }).sort((a, b) => (a.text > b.text) ? 1 : -1) : [],
            selectedOptions: state.filtersState.filters[ownProps.property] ? state.filtersState.filters[ownProps.property] : ""
        }
    }
    else {
        return {
            IsDisabled: false,
            options: options ? options.map(option => { return { text: option, value: option } }) : [],
            selectedOptions: state.filtersState.filters[ownProps.property] ? state.filtersState.filters[ownProps.property] : ""
        }
    }
    
}

export function mapDispatchToProps(dispatch: Dispatch, ownProps: IExternalProps): DispatchToProps {
    return {
        updateFilter: (query: string) => {
            if (!query || query === "") {
                dispatch(removeFilter(ownProps.property));
            } else {
                dispatch(goToPage(1));
                dispatch(upsertFilter(ownProps.property, query) as any)
            }
        },
        updateSecondaryFilter: (property: string, query: string) => {
            if (!query || query === "") {
                dispatch(removeFilter(property));
            } else {
                dispatch(upsertFilter(property, encodeURIComponent(query)) as any)
            }
        }
    }
}


